export default __webpack_public_path__ + "c9be4e003cd83a97223b66f1e23ed7bf.svg";